import openWelcomePopup from "components/page/popup/WelcomePopup";

import Constants from "utils/constants";

export const handleAuthSuccess = ({ data, navigate, next, queryClient }) => {
    if (data?.is_coupon_issued) {
        openWelcomePopup({ navigate, private_space_uuid: data.private_space_uuid });
    }

    localStorage.setItem("token", data.auth_token);

    if (queryClient) {
        queryClient.invalidateQueries("user");
        queryClient.invalidateQueries("spaceMember");
    }

    if (next) {
        navigate(next);
    } else {
        navigate(`/`);
    }
};

export const isReadonlyUser = (user) => {
    return user?.current_space && (!isActiveSpace(user?.current_space) || isViewerUser(user));
};

export const isAdminUser = (user) => {
    const role = user?.current_space?.my_member_info?.role;
    return role && role === Constants.SPACE_MEMBER_ROLE_ADMIN;
};

export const isAdminMember = (member) => {
    const role = member?.role;
    return role && role === Constants.SPACE_MEMBER_ROLE_ADMIN;
};

export const isViewerUser = (user) => {
    const role = user?.current_space?.my_member_info?.role;
    return role && role === Constants.SPACE_MEMBER_ROLE_VIEWER;
};

export const isActiveSpace = (space) => {
    const status = space?.status;
    return status && status === Constants.SPACE_STATUS_ACTIVE;
};

export const isPrivateSpace = (space) => {
    const scope = space?.scope;
    return scope && scope === Constants.SPACE_SCOPE_PRIVATE;
};
